import {
  Button,
  DialogTrigger,
  makeStyles,
  tokens,
  mergeClasses,
} from "@fluentui/react-components";
import React from "react";
import {
  onBackBtnClick,
  onStepBtnClick,
} from "../../helper/signGeneratorHelper";
import { useTranslation } from "react-i18next";
import { IOrderStatus } from "../../interfaces/IOrderStatus";
import { ISignGenerate } from "../../interfaces/ISignGenerate";
import { UseFormReturn } from "react-hook-form";
import { ISignForm } from "../../interfaces/ISignForm";
type ModalButtonsProps = {
  signForm: UseFormReturn<ISignForm, any, ISignForm>;
  orderStatus: IOrderStatus;
  step: number;
  loading: boolean;
  setOrderStatus: React.Dispatch<React.SetStateAction<IOrderStatus>>;
  setGenerateSign: React.Dispatch<React.SetStateAction<ISignGenerate>>;
  setCheckoutModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
};

const useStyles = makeStyles({
  footer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: tokens.spacingVerticalL,
    paddingTop: tokens.spacingVerticalL,
  },
  borderTop: {
    borderTop: `1px solid ${tokens.colorNeutralStroke1}`,
  },
});
export const ModalButtons = ({
  signForm,
  orderStatus,
  step,
  loading,
  setOrderStatus,
  setGenerateSign,
  setCheckoutModalOpen,
  setStep,
  onSubmit,
}: ModalButtonsProps) => {
  const styles = useStyles();
  const { t } = useTranslation();
  const ataHomePageUrl = process.env.REACT_APP_ATA_HOMEPAGE_URL;
  return (
    <div
      className={mergeClasses(
        styles.footer,
        !orderStatus?.orderSent && styles.borderTop
      )}
    >
      <DialogTrigger disableButtonEnhancement>
        <Button
          appearance="secondary"
          size="large"
          disabled={loading}
          onClick={() => {
            onBackBtnClick(
              orderStatus,
              step,
              setOrderStatus,
              setGenerateSign,
              setCheckoutModalOpen,
              setStep
            );
          }}
        >
          {t(
            orderStatus?.orderSent
              ? "button.designNewSign"
              : step === 2 && !orderStatus?.error
              ? "button.back"
              : "button.continueDesigning"
          )}
        </Button>
      </DialogTrigger>

      {!orderStatus?.error && (
        <Button
          appearance="primary"
          size="large"
          type={step === 2 ? "submit" : "button"}
          disabled={loading}
          onClick={() => {
            if (orderStatus?.orderSent) {
              window.location.href = ataHomePageUrl;
            } else {
              onStepBtnClick(
                signForm,
                orderStatus,
                step,
                setOrderStatus,
                setGenerateSign,
                setCheckoutModalOpen,
                setStep,
                onSubmit
              );
            }
          }}
        >
          {t(
            orderStatus?.orderSent
              ? "button.backToWebsite"
              : step === 1
              ? "button.next"
              : "button.sendOrder"
          )}
        </Button>
      )}
    </div>
  );
};
